import React from "react";
import { Row, Col } from "react-bootstrap";

const MensagemSucesso = ({ mensagem }) => {
  if (!mensagem) return null;

  return (
    <div className="resultado-simulacao-emprestimo" style={{ marginBottom: "10px" }}>
      <Row>
        <Col sm={12}>
          <div className="alert alert-success" role="alert">
            <span>
              <i className="fa fa-check-circle" aria-hidden="true"></i>
            </span>
            <span style={{ marginLeft: "10px" }} dangerouslySetInnerHTML={{ __html: mensagem }}></span>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MensagemSucesso;